import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import Link from "./link"

const StyledLink = styled(Link)`
  margin-top: ${4 * tokens.size.base}px;
  margin-bottom: ${4.5 * tokens.size.base}px;
  color: ${tokens.color.text.muted};
  font-size: ${tokens.fontSize.text.s};
  display: inline-block;
`
function PageFooter({ editUrl }) {
  return editUrl ? (
    <StyledLink href={editUrl}>Edit this page on GitHub</StyledLink>
  ) : null
}

PageFooter.propTypes = {
  editUrl: PropTypes.string,
}

export default PageFooter
